<template>
  <div class="main">
    <el-dialog
      title="人员信息"
      :visible.sync="openData.personState"
      width="60%"
      class="dialog_container"
      @close="handleClose"
    >
      <div class="dialog_content">
        <el-form
          :inline="true"
          class="demo-form-inline"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          <el-form-item label="姓名:">
            <el-input
              v-model="customerName"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="身份证号:"
            style="margin-left: 30px"
          >
            <el-input
              v-model="customerIdcard"
              placeholder="请输入身份证号"
            ></el-input>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button
              type="primary"
              @click="searchData"
            >查询</el-button>
            <!-- <el-button type="info" >重置</el-button> -->
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
          border
        >
          <el-table-column
            width="55"
            label="选择"
            align="center"
          >
            <template slot-scope="scope">
              <el-radio
                :label="scope.row.id"
                v-model="radioId"
                @change="rowClick(scope.row)"
              >&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            type="index"
            width="70"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="customerName"
            label="姓名"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="customerIdcard"
            label="身份证号"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="customerPhone"
            label="手机号"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="customerAge"
            label="年龄"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="customerSex"
            label="性别"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customerSex == 0">男</span>
              <span v-if="scope.row.customerSex == 1">女</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="saveRY"
        >确 定</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["openData"],
  data() {
    return {
      tableData: [],
      customerName: "",
      customerIdcard: "",
      total: 0,
      pageSize: 10,
      pageNo: 1,
      radioId: "",
      info: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取内容
    rowClick(row) {
      this.info = { ...row }
    },
    // 查询条件
    searchData() {
      this.getList()
    },
    //确定
    saveRY() {
      this.info.orderWay = "0"
      this.$emit("update:value", this.info)
    },
    // 获取列表
    getList() {
      let params = {
        customerId: this.openData.customerId,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        orderId: this.openData.id,
        customerName: this.customerName,
        customerIdcard: this.customerIdcard,
      }
      this.$http
        .request({
          url: "/sqyl/admin/customer/info/findList",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.total = 0
              return
            }
            this.tableData = res.content.list
            this.total = res.content.count
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.getList()
    },
    // 关闭
    handleClose() {
      this.$emit("cancleOpen", "")
    },
  },
}
</script>
<style lang="less" scoped></style>
  